import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import LoginLogo from '../../Assets/images/Frame 39059 1.png';
import LoginImg from '../../Assets/images/Loginimage-woman-smile-happy-joy 1.png';
import BackgroundImage from '../../Assets/images/LoginAndSignUpBG.png';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'; // Import SweetAlert2
import { API_BASE_URL } from '../../config';
const Login = ({ onLogin }) => {
  const [rememberMe, setRememberMe] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [userMobile, setUserMobile] = useState('');
  const [password, setPassword] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Step 1: Autofill values from storage after logout
  useEffect(() => {
    // Retrieve stored mobile and password
    const storedMobile = localStorage.getItem('userMobile');
    const storedPassword = localStorage.getItem('password');
    const storedRole = localStorage.getItem('selectedRole');

    if (storedMobile) {
      setUserMobile(storedMobile);
    }
    if (storedPassword) {
      setPassword(storedPassword);
    }
    if (storedRole) {
      setSelectedRole(storedRole);
    }
  }, []); // Empty dependency array means this runs once on mount

  const handleSignUpClick = () => {
    navigate('/signup');
  };

  const handleForgotPassword = () => {
    navigate('/forgotPassword');
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!userMobile) {
      newErrors.userMobile = 'Mobile Number is required';
    }
    if (!password) {
      newErrors.password = 'Password is required';
    }
    if (!selectedRole) {
      newErrors.role = 'Please select a role';
    }
    return newErrors;
  };

  const handleLogin = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
      try {
        const headers = {
          'Content-Type': 'application/json',
          'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC',
        };

        const response = await axios.post(
          `${API_BASE_URL}/account/login/`,
          // 'https://finwise-backend.vercel.app/account/login/',
          // 'https://finwiseback.finwise.com.bd/account/login/',
          // 'http://127.0.0.1:8000/account/login/',
          {
            user_type: selectedRole.toLowerCase(),
            phone: userMobile,
            password: password,
          },
          {
            headers: headers,
            withCredentials: true,
          }
        );

        if (response.status === 200) {
          if (rememberMe) {
            localStorage.setItem('userMobile', userMobile);
            localStorage.setItem('password', password);
            localStorage.setItem('selectedRole', selectedRole);
            // console.log('Stored in localStorage:');
            // console.log('User Mobile:', userMobile);
            // console.log('Password:', password);
            // console.log('selectedRole:', selectedRole);
          } else {
            sessionStorage.setItem('userMobile', userMobile);
            sessionStorage.setItem('password', password);
            localStorage.setItem('selectedRole', selectedRole);
            // console.log('Stored in sessionStorage:');
            // console.log('User Mobile:', userMobile);
            // console.log('Password:', password);
            //  console.log('selectedRole:', selectedRole);
          }

          // Perform any additional login actions
          onLogin();

          Swal.fire({
            title: 'Login Successful',
            text: 'Welcome to FIN WISE.',
            customClass: {
              popup: 'w-80 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              confirmButton:
                'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          }).then(() => {
            navigate('/dashboard'); // Navigate to the dashboard
          });
        } else {
          Swal.fire({
            title: 'Login Failed',
            text: 'Your mobile number or password is incorrect.',
            customClass: {
              popup: 'w-80 h-auto p-3',
              title: 'text-lg',
              content: 'text-xs',
              confirmButton:
                'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
            },
          });
        }
      } catch (error) {
        Swal.fire({
          title: 'Login Error',
          text:
            error.response.data.non_field_errors ||
            'An unexpected error occurred.',
          customClass: {
            popup: 'w-80 h-auto p-3',
            title: 'text-lg',
            content: 'text-xs',
            confirmButton:
              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
          },
        });
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen md:py-0 py-2 md:mt-16 mt-24"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <div className="bg-white md:p-2 p-8 lg:pl-10 lg:pr-10 gap-10 shadow-xl rounded-xl">
        {/* top secton */}
        <div className="items-center justify-center flex">
          <img
            src={LoginLogo}
            alt="LoginLogo"
            className="md:h-16 h-10 lg:h-16 mb-0 pr-10 lg:mb-1"
          />
        </div>
        <h2 className="items-center justify-center flex lg:font-bold lg:mb-4 text-xs lg:text-sm">
          Trade and Finance Solutions
        </h2>
        <div className="items-center justify-center flex flex-col lg:flex-row gap-10">
          {/* left section */}
          <div className="lg:block hidden">
            <img
              src={LoginImg}
              alt="LoginImg"
              className="md:h-40 h-32 lg:h-44"
            />
          </div>

          {/* right section */}
          <div className="">
            <h2 className="text-xl text-center lg:text-2xl font-semibold mt-1 mb-2 heading">
              Log In
            </h2>

            <div className="w-full space-y-2 mt-2 text-xs ">
              {/* Radio Buttons */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                <label className="flex items-center space-x-2 border-2 p-2 border-gray-300 rounded-md w-full">
                  <input
                    type="radio"
                    name="role"
                    className="hidden peer"
                    value="corporate"
                    // value={selectedRole}
                    checked={selectedRole === 'corporate'}
                    onChange={e => setSelectedRole(e.target.value)}
                  />
                  <div className="w-3 h-3 border-2 ring-2 ring-gray-500 border-gray-300 rounded-full peer-checked:bg-gray-500"></div>
                  <span className="p-0.5  text-gray-500">Corporate</span>
                </label>

                <label className="flex items-center space-x-2 border-2 p-2 border-gray-300 rounded-md w-full">
                  <input
                    type="radio"
                    name="role"
                    className="hidden peer"
                    value="bank"
                    // value={selectedRole}
                    checked={selectedRole === 'bank'}
                    onChange={e => setSelectedRole(e.target.value)}
                  />
                  <div className="w-3 h-3 border-2 ring-2 ring-gray-500 border-gray-300 rounded-full peer-checked:bg-gray-500"></div>
                  <span className="p-0.5 md:block flex md:gap-0 gap-2 text-gray-500">
                    Bank
                  </span>
                </label>

                <label className="flex items-center space-x-2 border-2 p-2 border-gray-300 rounded-md w-full">
                  <input
                    type="radio"
                    name="role"
                    className="hidden peer"
                    value="individual"
                    // value={selectedRole}
                    checked={selectedRole === 'individual'}
                    onChange={e => setSelectedRole(e.target.value)}
                  />
                  <div className="w-3 h-3 border-2 ring-2 ring-gray-500 border-gray-300 rounded-full peer-checked:bg-gray-500"></div>
                  <span className="p-0.5 md:block flex md:gap-0 gap-2 text-gray-500">
                    Individuals
                  </span>
                </label>
              </div>
              {errors.role && (
                <p className="text-red-500 text-xs text-left mb-0 -mt-2">
                  {errors.role}
                </p>
              )}

              {/* Input Fields */}
              <div className="flex flex-col space-y-4 ">
                <input
                  type="text"
                  placeholder="+880 Mobile Number"
                  className="border border-gray-300 rounded-md py-2 px-4 w-full"
                  value={userMobile}
                  onChange={e => setUserMobile(e.target.value)}
                  onKeyDown={handleKeyDown}
                  onInput={e => {
                    let inputValue = e.target.value;
                    // Allow only one "+" at the beginning and numbers after
                    inputValue = inputValue.replace(/[^0-9+]/g, ''); // Only keep numbers and "+"
                    inputValue = inputValue.replace(/(?!^)\+/g, ''); // Remove "+" if it's not at the beginning
                    e.target.value = inputValue;
                  }}
                  min="0"
                />
                {errors.userMobile && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.userMobile}
                  </p>
                )}
                <div className="relative w-full">
                  <input
                    type={passwordVisible ? 'text' : 'password'}
                    placeholder="Password"
                    className="border border-gray-300 rounded-md py-2 px-4 w-full"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
                  >
                    {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                    <span className="ml-1 text-sm">
                      {passwordVisible ? 'Hide' : 'Show'}
                    </span>
                  </button>
                </div>
                {errors.password && (
                  <p className="text-red-500 text-xs mb-0 -mt-2">
                    {errors.password}
                  </p>
                )}
              </div>

              {/* remember me and forgot password */}
              <div className="flex justify-between items-center">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="remember-me"
                    checked={rememberMe}
                    // value="rememberMe"
                    // checked={rememberMe === rememberMe}
                    onChange={() => setRememberMe(prev => !prev)} // Toggle rememberMe state
                    // onChange={() => setRememberMe(!rememberMe)}
                    className="mr-1 ml-1"
                  />
                  <label
                    htmlFor="remember-me"
                    className=" text-xs text-gray-500"
                  >
                    Remember Me
                  </label>
                </div>
                <button
                  onClick={handleForgotPassword}
                  className="text-xs text-blue-500 hover:underline"
                >
                  Forgot Password?
                </button>
              </div>

              {/* Login Button */}
              <button
                onClick={handleLogin}
                className="w-full bg-orange-300 text-white py-2 px-6 hover:bg-btnHover mb-1 mt-2 rounded-2xl"
              >
                Login
              </button>
              {/* dont have an account */}
              <p className="mb-0 text-center text-gray-600 text-xs">
                Don't have an account?
                <button onClick={handleSignUpClick} className="underline ml-2">
                  SignUp
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;




